<template>
  <div class="canvas-toolbox">
    <transition name="slide">
      <tr-canvas-toolbox class="toolbox-class" v-if="showCanvasToolbox"> </tr-canvas-toolbox>
    </transition>
  </div>
</template>
<script>
// import SystemInformation from './LandingPage/SystemInformation';
import TrCanvasToolbox from './TrCanvasToolbox/TrCanvasToolbox';
export default {
  name: 'tr-navi-canvas-toolbox',
  data: function () {
    return {};
  },
  components: {
    TrCanvasToolbox,
  },
  methods: {},
  computed: {
    showCanvasToolbox() {
      return this.$store.getters.showCanvasToolbox;
    },
  },
};
</script>

<style lang="scss">
$width: 1171px;
$height: 70px;
.canvas-toolbox {
  position: absolute;
  top: -5px;
  left: 149px;
  // z-index: 300 !important;
}
.toolbox-class {
  width: $width;
  height: $height;
  // opacity: 1;
  display: flex;
  flex-direction: column;
}
</style>
